import { useEffect, useSyncExternalStore } from 'react';

import { initializeMicrosoftClarity } from '@/lib/clarity';
import { readCookieConsent, subscribeToCookieConsent } from '@/lib/cookie-consent';

export function MicrosoftClarity() {
  const consent = useSyncExternalStore(subscribeToCookieConsent, readCookieConsent, () => null);

  useEffect(() => {
    if (consent === 'accepted') initializeMicrosoftClarity();
  }, [consent]);

  return null;
}
